import {useCurrentRoute} from './useCurrentRoute';

/**
 * Hook to determine if the current route is private and if it exists.
 *
 * @returns {Object} Object containing:
 *   - isPrivateRoute: boolean - Whether the current route requires authentication
 *   - isRouteExist: boolean - Whether the current route exists in the route configuration
 */
export default function useIsPrivateRoute() {
    const currentRoute = useCurrentRoute();

    const isPrivateRoute = currentRoute?.isPrivate || false;
    const isRouteExist = !!currentRoute;

    return {isPrivateRoute, isRouteExist};
}
